import { setActivePage } from 'src/pages/NavigationShell/NavigationShell.slice';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { isNil } from 'lodash';
import { RightContainerPayloadType } from 'src/components/RightContainer/RightContainer';

interface CollapsingPayload {
  type: RightContainerPayloadType.Collapsing;
}
export interface HistoryPayload {
  type: RightContainerPayloadType.History;
  id: string;
  parentId: string;
  styleColorName?: string;
  isAssortmentBuild?: boolean;
}
export interface AssortmentPayload {
  type: RightContainerPayloadType.Assortment;
  id: string;
  parentId: string;
  styleColorName?: string;
  isAssortmentBuild: boolean;
}
export interface FilterPayload {
  type: RightContainerPayloadType.Filter;
}
export interface PlanQueuePayload {
  type: RightContainerPayloadType.PlanQueue;
  id: string;
}
export interface UndoPayload {
  type: RightContainerPayloadType.Undo;
}
export interface CommentsPayload {
  type: RightContainerPayloadType.Comments;
}
export interface AgentPayload {
  type: RightContainerPayloadType.Agent;
  id: string;
}

export type ContainerPayload =
  | CollapsingPayload
  | HistoryPayload
  | AssortmentPayload
  | FilterPayload
  | PlanQueuePayload
  | UndoPayload
  | CommentsPayload
  | AgentPayload;
export interface RightContainerSlice {
  payload?: ContainerPayload;
  open: boolean;
}

const initialRightContainerState: RightContainerSlice = {
  open: false,
  payload: undefined,
};

const rightContainerReducer = createSlice({
  name: 'RightContainer',
  initialState: initialRightContainerState,
  reducers: {
    setRightContainerPayload: (state, action: PayloadAction<ContainerPayload>) => {
      state.payload = action.payload;
      state.open = true;
    },
    clearAndCloseRightContainer: (state) => {
      state.open = false;
      state.payload = { type: RightContainerPayloadType.Collapsing };
    },
    cleanUpRightContainer: () => {
      return initialRightContainerState;
    },
    toggleRightContainer: (state) => {
      state.open = !state.open;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(setActivePage, (state) => {
      const currentPayload = state.payload;
      state.open = false;

      // only set to collapsing if a payload was previously set,
      // this prevents the payload type being set on initial app load
      // causing the container to animate open to closed
      state.payload = isNil(currentPayload) ? undefined : { type: RightContainerPayloadType.Collapsing };
    });
  },
});

export const {
  setRightContainerPayload,
  clearAndCloseRightContainer,
  cleanUpRightContainer,
  toggleRightContainer,
} = rightContainerReducer.actions;

export default rightContainerReducer.reducer;
